export default "<router-outlet></router-outlet>\n<ng-http-loader [backgroundColor]=\"'#03396C'\" [opacity]=\"1\"></ng-http-loader>\n"